import { isPresent } from 'utils/isPresent';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ConfirmationDialog from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/ConfirmationDialog';
import DialogContentText from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogContentText';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import HousecallThemeProvider from 'housecall-ui/dist/DesignSystem/Styles/HousecallThemeProvider';
import PropTypes from 'prop-types';

import reducerRegistry from '../../Common/Data/ReducerRegistry';

import { clearCustomerInitialFields } from './Redux/Actions';
import { isCustomerInfoFormFilled } from './Redux/Data';
import AddOrEditCustomerReducer from './Redux/Reducer';
import CustomerForm from './CustomerForm';

const NEW_CUSTOMER = 'Add new customer';
const EDIT_CUSTOMER = 'Edit customer';

@connect(
  (state, props) => ({
    open: props.open,
    isFormFilled: isCustomerInfoFormFilled(state),
  }),
  { clearCustomerInitialFields }
)
export default class AddOrEditCustomerDialog extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      openConfirmDiscardDialog: false,
    };
  }

  componentDidMount() {
    if (reducerRegistry.isReducerPresent('addOrEditCustomer') === false) {
      reducerRegistry.register('addOrEditCustomer', AddOrEditCustomerReducer);
    }
  }

  handleClose() {
    isPresent(this.props.onClose) ? this.props.onClose() : this.props.closeDialog(false);
  }

  close(dirty) {
    if (dirty && this.props.isFormFilled) {
      this.setState({ openConfirmDiscardDialog: true });
    } else {
      this.handleClose();
    }
    this.props.clearCustomerInitialFields();
  }

  render() {
    if (this.props.open) {
      return (
        <HousecallThemeProvider>
          <CustomerForm
            title={this.props.editCustomer ? EDIT_CUSTOMER : NEW_CUSTOMER}
            action={this.props.editCustomer ? 'update' : 'create'}
            openDialog={this.props.open}
            onSuccess={this.props.onSuccess}
            onSelectCustomer={this.props.onSelectCustomer}
            close={(dirty) => {
              this.close(dirty);
            }}
          />
          <ConfirmationDialog
            open={this.state.openConfirmDiscardDialog}
            onClose={() => this.setState({ openConfirmDiscardDialog: false })}
            title="Are you sure?"
            leftButton={
              <Button color="secondary" onClick={() => this.setState({ openConfirmDiscardDialog: false })}>
                Cancel
              </Button>
            }
            rightButton={
              <Button
                color="primary"
                onClick={() => {
                  this.handleClose();
                  this.setState({ openConfirmDiscardDialog: false });
                }}
              >
                Confirm
              </Button>
            }
          >
            <DialogContentText>Your changes will be discarded</DialogContentText>
          </ConfirmationDialog>
        </HousecallThemeProvider>
      );
    }
    return null;
  }
}

AddOrEditCustomerDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onSuccess: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
};

AddOrEditCustomerDialog.defaultProps = {
  title: NEW_CUSTOMER,
  action: 'create',
  open: false,
  onSuccess: () => {},
  closeDialog: () => {},
};
